export const resourceGroupOptions = [
  { key: 0, display_name: '全部' },
  { key: 1, display_name: '影片' },
  { key: 2, display_name: '教案與文件' },
  { key: 3, display_name: '視覺資源' },
  { key: 4, display_name: '懶人包' }
]

export const resourceGroupOptionsKeyValue = resourceGroupOptions.reduce((acc, cur) => {
  acc[cur.key] = cur.display_name
  return acc
}, {})

export const classOptions = [
  { key: 1, display_name: '收容所' },
  { key: 2, display_name: '結紮' },
  { key: 4, display_name: '流浪動物' },
  { key: 8, display_name: '放養' },
  { key: 16, display_name: '生命教育' },
  { key: 32, display_name: '人犬衝突' },
  { key: 64, display_name: '十二夜' },
  { key: 128, display_name: '十二夜2' },
  { key: 256, display_name: '晶片' },
  { key: 512, display_name: '領養' }
]

export const classOptionsKeyValue = classOptions.reduce((acc, cur) => {
  acc[cur.key] = cur.display_name
  return acc
}, {})
